import "@fontsource/noto-sans-tc/400.css";
import "@fontsource/noto-sans-tc/500.css";
import "@fontsource/noto-sans-tc/600.css";
import "@fontsource/noto-sans-tc/700.css";
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/400.css";

import './js/sweetalert'

import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade , Thumbs } from 'swiper/modules';
import 'swiper/css/bundle';
// import './js/template-demo.js';
import './js/article_sidemenu';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs]);
window.Swiper = Swiper;

// templates
import './js/templates/home.js';
import './js/templates/faq.js';
import './js/templates/milestone.js';
import './js/templates/products.js';
import './js/templates/services.js';


// JavaScript
$(document).ready( function () {
  // dropdown
  $('.dropdown-btn').on('click', function () {
    const id = $(this).attr('id');
    const dropdown_is_active = $('[aria-labelledby=' + id + ']').hasClass("is-active");
    if (dropdown_is_active >= 1) {
      $('[aria-labelledby=' + id + ']').removeClass('is-active');
      if (window.innerWidth <= 640) {
        $('body').css({
          'height': '',
          'overflow': '',
        })
      }
    } else {
      $(".dropdown-list:not([aria-labelledby=" + id + "]").removeClass('is-active');
      $('[aria-labelledby=' + id + ']').addClass('is-active');
      if (window.innerWidth <= 640) {
        $('body').css({
          'height': '100vh',
          'overflow': 'hidden',
        })
      }
    }
  });

  $(document).click(function (event) {
    if (!$(event.target).closest('.dropdown-btn').length) {
      if ($('.dropdown-list').is(":visible")) {
        $(".dropdown-list").removeClass('is-active');
        if (window.innerWidth <= 640) {
          $('body').css({
            'height': '',
            'overflow': '',
          })
        }
      }
    }
  });

  // header transparent effect (首頁電腦版)
  function headerScroll() {
    if ($(window).scrollTop() > 100) {
      $('.header').addClass("min-header");
    } else {
      $('.header').removeClass("min-header");
    }
  }
  headerScroll();
  $(window).on('scroll', function () {
    headerScroll();
  });

  // header 漢堡選單按鈕 (手機版)
  $('.header-mobile-menu').on('click', function () {
    $(this).toggleClass('active');
    $('.header-menu-outer').toggleClass('active');
  });

  // header 下拉選單箭頭按鈕: 控制子選單開啟 (手機版)
  $('.menu-dropdown-toggle').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if ( $(window).width() > 800 ) return;

    const $parent = $(this).closest('.header-menu-link, .dropdown-link');
    const $siblings = $parent.siblings();
    const isActive = $parent.hasClass('active');
    $siblings.removeClass('active');
    $parent.toggleClass('active', !isActive); // 明確設定，避免雙觸發時抵銷
  });

  // 控制 header 子選單 開啟方向 (電腦版): 預設右開, 若右側空間不足則由左側開啟
  function updateMenuOpenDirection() {
    if ( $(window).width() <= 800 ) {
      $('.header-menu-link, .dropdown-link').removeClass('open-to-left');
      return;
    }
    const windowWidth = window.innerWidth;
    $('.header-menu-link').each(function () {
      const $item = $(this);
      const itemRightOffset = windowWidth - ($item.offset().left + $item.outerWidth());
      const hasSubMenu = $item.find('.sub-menu-dropdown').length > 0;
      const threshold = hasSubMenu ? 460 : 230;  // 子選單寬度 230px
      const shouldOpenLeft = itemRightOffset < threshold;
      // 第一層子選單
      $item.toggleClass('open-to-left', shouldOpenLeft);
      // 第二層子選單
      $item.find('.dropdown-link.dropdown').toggleClass('open-to-left', shouldOpenLeft);
    });
  }
  // init
  updateMenuOpenDirection();  // 控制 header 子選單 左開/右開 (電腦版)
  // resize
  let headerOpenSetResizeTimer;
  $(window).on('resize', function() {
    clearTimeout(headerOpenSetResizeTimer);
    headerOpenSetResizeTimer = setTimeout(updateMenuOpenDirection, 150);  // 控制 header 子選單 左開/右開 (電腦版)
  });


  // page top button
  $('#js-pagetop').on('click', function() {
    $('html, body').animate({
        scrollTop: 0
    }, 1000);
    return false;
  });

  // 首頁彈窗 popup
  const $popupWrap = $('#js-custom-popup-content');
  if ( $popupWrap.length!=0 && !Cookies.get('index_popup') ) {
    Swal.fire({
      html: $popupWrap.html(),
      showCloseButton: true,
      closeButtonHtml: '',
      showConfirmButton: false,
      showCancelButton: false,
      focusDeny: false,
      focusClose: false,
      customClass: {
        popup: 'index-popup',
      },
      didOpen: (popup) => {
        popup.focus({ preventScroll: true }); // 將焦點移到彈窗本體（而不是按鈕）
      }
    })
    .then(() => { // popup 關閉後
      Cookies.set('index_popup', 'seen', { expires: 1 })
    });
  }

});
